module.exports = __webpack_public_path__ + "806430afac3b1ddf85e9e57b8335f2c1.glb";